import {isTauri} from '@tauri-apps/api/core'

export const isTauriRuntime = () => isTauri()

export const POS_API_ORIGIN = 'https://chromaworks.co.kr'
